import { $, $$ } from './../helpers/qsa'
import 'whatwg-fetch'

$$('#register-interest form').forEach(form => {
    const btn = $('.btn', form)

    form.addEventListener('submit', e => {
        e.preventDefault()

        // Disable button
        btn.setAttribute('disabled', 'disabled')

        fetch('/wp/wp-admin/admin-ajax.php?action=pmb_register_interest', {
            method: 'POST',
            body: new FormData(form)
        })
        .then(response => response.json())
        .then(json => {
            if ( json.success ) {
                // Show success
                btn.insertAdjacentHTML('beforebegin', '<p class="success">Thank you!</p>')
                btn.parentNode.removeChild(btn)
            } else {
                // Show error
                btn.insertAdjacentHTML('beforebegin', '<p class="error">Oops, there was an error.<br>Please try again.</p>')

                // Re-enable button
                btn.removeAttribute('disabled')
            }
        })
    })
})
